import type { ReactNode } from "react";
import type { GenieIconName } from "@/components/ui/genie-icons/genie-icons";
import { GenieIcon } from "@/components/ui/genie-icons/GenieIcon";

interface ConversationSectionCardProps {
  title: string;
  genieIcon: GenieIconName;
  /** Control shown on the right of the header (a link, a button). */
  action?: ReactNode;
  children: ReactNode;
}

/**
 * Section chrome for the conversation details page: Help Genie gradient
 * border with a brand-tinted header. Every section uses the product's own
 * look, never the genie's branding colour, so the page reads as one piece.
 */
export const ConversationSectionCard = ({ title, genieIcon, action, children }: ConversationSectionCardProps) => (
  <div className="p-[2px] rounded-2xl bg-gradient-to-r from-[#4E9CFF] to-[#FF4DB8] shadow-sm">
    <div className="rounded-[14px] bg-white overflow-hidden">
      <div
        className="px-5 md:px-6 py-4 border-b border-[#4E9CFF]/10"
        style={{
          background: "linear-gradient(135deg, rgba(78,156,255,0.06) 0%, rgba(255,77,184,0.06) 100%)",
        }}
      >
        <div className="flex items-center justify-between gap-3">
          <div className="flex items-center gap-3 min-w-0">
            <GenieIcon
              name={genieIcon}
              size={26}
              color="#4E9CFF"
              secondaryColor="#FF4DB8"
              gradientEnabled
              label={title}
            />
            <h3 className="text-base font-bold text-gray-900">{title}</h3>
          </div>
          {action}
        </div>
      </div>
      <div className="px-5 md:px-6 py-5">{children}</div>
    </div>
  </div>
);
